<template>
	<div
		v-if="!hideTopNav"
		class="fixed navbar bg-navs z-30 topNavComp">
		<div class="container mx-auto flex items-center">
			<div class="flex-grow flex justify-center">
				<p
					v-if="currentPageTitle"
					class="page-title text-navsHover">
					{{ currentPageTitle }}
				</p>
				<img
					v-else
					class="w-10 h-10"
					:src="logo"
					alt="logo" />
			</div>
		</div>
	</div>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()
	const settingsStore = useSettingsStore()
	const { currentPageTitle, hideTopNav } = storeToRefs(settingsStore)
	const logo = runtimeConfig.public.IMAGES.LOGO_CONDENSED
</script>

<style scoped></style>
